<section class="TableCard">
  <div class="TableCard__Label" tabindex="0">
    <h5 class="TableCard__LabelText">{{ headerText }}</h5>
    <ng-content select="[label]"></ng-content>
    <ng-content select="[tooltip]"></ng-content>
    <ng-content select="[button]"></ng-content>
  </div>
  <ul class="TableCard__Body">
    @for (line of tableData; track line) {
      @if (line.header && line.contents) {
        <li class="TableCard__Line" tabindex="0">
          <p class="TableCard__Header" [innerHtml]="line.header"></p>
          <p class="TableCard__Contents" [innerHtml]="line.contents"></p>
        </li>
      }
    }
  </ul>
  <ng-content select="[messageBanner]"></ng-content>
</section>
